import PropTypes from "prop-types";
import React, { useImperativeHandle } from "react";
import { INVOICE_TYPE, INVOICE_TYPE_NEED_VAT_INFO, INVOICE_TYPE_NEED_VAT_CALC, RenderAmount, docTienBangChu } from "../../utils";
import moment from 'moment';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { post } from "../../helpers/api_helper";
import toastr from "toastr";

const ExportExcelComponentToPrint = React.forwardRef((props, ref) => {
  const {
    id, province, ward, listProduct, name, phone, street, addressFullText,
    total, productsAmount, vatAmount, costDeliver, deposit, email,
    createdAt,

    note,
    invoiceType,
    noteInvoice,
    codeVAT,
    companyNameVAT,
    addressVAT,

  } = props;
  const exportToCSV = () => {
    const isVAT = INVOICE_TYPE_NEED_VAT_CALC.includes(invoiceType);
    let totalCost = 0
    const address = addressFullText || `${street ? `${street}, ` : ''}${ward ? `${ward}, ` : ''}${province ? `${province}, ` : ''}`;
    const items = listProduct
      .map((item, i) => {
        const tempTotalCost = Number(item?.quantity || 0) * Number(item?.cost || 0)
        totalCost += tempTotalCost
        const pricePerUnit = Number(item?.price || 0) - Number(item.discountPerQuantity || 0)
        const total = Number(item?.quantity || 0) * pricePerUnit
        let vatPercent = null;

        let vatAmount = null;
        if (isVAT) {
          vatPercent = Number(item?.vatPercent || 0);
          vatAmount = Math.round(total * vatPercent / 100)
        }

        return {
          index: i + 1,
          name: item?.Product?.name || '',
          unit: item?.Product?.unit || '',
          vatPercent: vatPercent !== null ? `${vatPercent}%` : '',
          attributeTitle: item?.ProductAttribute?.attribute || '',
          externalId: item?.ProductAttribute?.externalId || '',
          quantity: item?.quantity || 0,
          costPerUnit: Number(item?.cost || 0),
          totalCost: tempTotalCost,
          pricePerUnit,
          total,
          vatAmount
        }
      });

    let vatInfo = '';
    if (INVOICE_TYPE_NEED_VAT_INFO.includes(invoiceType) && noteInvoice && !codeVAT) {
      vatInfo = noteInvoice;
    }
    if (INVOICE_TYPE_NEED_VAT_INFO.includes(invoiceType) && !!codeVAT) {
      vatInfo = `${companyNameVAT} - ${codeVAT} - ${addressVAT}`
    }

    post('/bills/export-excel', {
      items,
      id,
      total,
      productsAmount,
      vatAmount,
      costDeliver,
      name,
      phone,
      email,
      address,
      totalText: docTienBangChu(total - deposit),
      totalCost,
      deposit,
      payment: total - deposit,
      createdAt: moment(createdAt).format('HH:mm DD-MM-YYYY'),
      note,
      vatInfo,
    }, {
      responseType: 'blob'
    })
      .then((data) => {
        return FileSaver.saveAs(data, `hoa-don.xlsx`);
      })
      .catch(err => {
        toastr(err?.data?.error || 'Có lỗi xảy ra khi xuất excel, vui lòng thử lại sau', { appearance: 'error' })
      })

  }

  const exportToCSVWithCost = () => {
    const isVAT = INVOICE_TYPE_NEED_VAT_CALC.includes(invoiceType);
    let totalCost = 0
    const address = addressFullText || `${street ? `${street}, ` : ''}${ward ? `${ward}, ` : ''}${province ? `${province}, ` : ''}`;
    const items = listProduct
      .map((item, i) => {
        const tempTotalCost = Number(item?.quantity || 0) * Number(item?.cost || 0)
        totalCost += tempTotalCost
        const pricePerUnit = Number(item?.price || 0) - Number(item.discountPerQuantity || 0)
        const total = Number(item?.quantity || 0) * pricePerUnit
        let vatPercent = null;
        let vatAmount = null;
        if (isVAT) {
          vatPercent = Number(item?.vatPercent || 0);
          vatAmount = Math.round(total * vatPercent / 100)
        }
        return {
          index: i + 1,
          name: item?.Product?.name || '',
          unit: item?.Product?.unit || '',
          vatPercent: vatPercent !== null ? `${vatPercent}%` : '',
          attributeTitle: item?.ProductAttribute?.attribute || '',
          externalId: item?.ProductAttribute?.externalId || '',
          quantity: item?.quantity || 0,
          costPerUnit: Number(item?.cost || 0),
          totalCost: tempTotalCost,
          pricePerUnit,
          total,
          vatAmount
        }
      });
    let vatInfo = '';
    if (INVOICE_TYPE_NEED_VAT_INFO.includes(invoiceType) && noteInvoice && !codeVAT) {
      vatInfo = noteInvoice;
    }
    if (INVOICE_TYPE_NEED_VAT_INFO.includes(invoiceType) && !!codeVAT) {
      vatInfo = `${companyNameVAT} - ${codeVAT} - ${addressVAT}`
    }

    post('/bills/export-excel-with-cost', {
      items,
      id,
      total,
      productsAmount,
      vatAmount,
      costDeliver,
      name,
      phone,
      email,
      address,
      totalText: docTienBangChu(total - deposit),
      totalCost,
      deposit,
      payment: total - deposit,
      createdAt: moment(createdAt).format('HH:mm DD-MM-YYYY'),
      note,
      vatInfo,
    }, {
      responseType: 'blob'
    })
      .then((data) => {
        return FileSaver.saveAs(data, `hoa-don.xlsx`);
      })
      .catch(err => {
        toastr(err?.data?.error || 'Có lỗi xảy ra khi xuất excel, vui lòng thử lại sau', { appearance: 'error' })
      })

  }
  useImperativeHandle(ref, () => ({
    exportToCSV,
    exportToCSVWithCost
  }))

  return <></>
});

export default ExportExcelComponentToPrint;

ExportExcelComponentToPrint.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  street: PropTypes.string,
  addressFullText: PropTypes.string,
  phone: PropTypes.string,
  province: PropTypes.string,
  ward: PropTypes.string,
  listProduct: PropTypes.array,
  total: PropTypes.number,
  productsAmount: PropTypes.number,
  vatAmount: PropTypes.number,
  costDeliver: PropTypes.number,
  createdAt: PropTypes.string,

};
